import { render, staticRenderFns } from "./TeacherTopPage.vue?vue&type=template&id=70e39596&scoped=true"
import script from "./TeacherTopPage.vue?vue&type=script&lang=js"
export * from "./TeacherTopPage.vue?vue&type=script&lang=js"
import style0 from "./TeacherTopPage.vue?vue&type=style&index=0&id=70e39596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e39596",
  null
  
)

export default component.exports